/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {
  'use strict';

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.idspThemeViews = {
    attach: function (context, settings) {

      var $context = $(context);

      if(window.location.pathname === '/faktury') {
        var approverHeading = $context.find("#view-approver-table-column--2");
        var approverColumns = $context.find(".views-field-approver");

        if(approverHeading) {
          approverHeading.hide();
        }

        if(approverColumns) {
          approverColumns.hide();
        }
      }

      if(window.location.pathname === '/objednavky') {
        var orderIdHeading = $context.find("#view-order-id-table-column--2");
        var orderIdColumns = $context.find(".views-field-order-id");

        if(orderIdHeading) {
          orderIdHeading.hide();
        }

        if(orderIdColumns) {
          orderIdColumns.hide();
        }
      }

    }
  };

})(Drupal, jQuery);
